import { LogoutOptions, useAuth0 } from '@auth0/auth0-react'
import { setOrganizationId } from '@lib/graphql/variables/organizationId'
import * as LocalStorage from '@utils/LocalStorage'
import { AUTH_LOGOUT_STATE } from '@utils/LocalStorage'
import { useCallback } from 'react'

const useLogout = () => {
  const { logout } = useAuth0()

  const logoutClient = useCallback(
    (options?: LogoutOptions) => {
      logout(options)

      LocalStorage.storeState(AUTH_LOGOUT_STATE, Date.now().toString())
      setOrganizationId(null)
    },
    [logout],
  )

  return { logoutClient }
}

export default useLogout
